import { defineComponent as _defineComponent } from 'vue'
import { unref, computed } from 'vue';
    import WarningBanner from '@ve/components/banners/warninigBanner/common/WarningBanner.vue';
    import { useHotelDescriptionRepository } from '@entities/hotelDescription';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HotelDescriptionImportant',
  setup(__props) {

    const { hotelDescriptionImportant } = useHotelDescriptionRepository();
    const isImportantExists = computed(() => unref(hotelDescriptionImportant));

return { __sfc: true,hotelDescriptionImportant, isImportantExists, WarningBanner }
}

})